export default "__VITE_ASSET__BJ_6RZgs__"